import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Surface } from '../../UI/Surface';

export const Strip = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: theme.palette.tokens.space[3],
}));

export const Card = styled(Surface)(({ theme }) => {
  const { space } = theme.palette.tokens;
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: `${space[3]}px ${space[4]}px`,
    minHeight: '72px',
  };
});

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
}));

export const Value = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.text.primary,
  fontVariantNumeric: 'tabular-nums lining-nums',
  fontFeatureSettings: '"tnum" 1, "lnum" 1',
}));

export const Hint = styled('span')(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.disabled,
  marginLeft: '6px',
}));
